import {
  Autocomplete,
  FormGroup,
  InputLabel,
  TextField,
  Typography,
} from "@mui/material";
import ErrorMessageTypo from "./ErrorMessageTypo";
import Label from "./Label";

const _SELECT_DEFAULT = "Veuillez selectionner une option";

export const BasicFormikAutocomplete = ({
  field,
  fieldId,
  formik,
  options,
  placeholder,
  helperText,
  multiple = false,
  labelAlignement = null,
}) => {
  const label = field.spec.label;
  const key = fieldId;

  return (
    <>
      {labelAlignement && <Label label={label} />}
      <FormGroup
        key={key}
        sx={{
          marginTop: 1,
          width: "100%",
        }}
      >
        {!labelAlignement && <InputLabel htmlFor={fieldId}>{label}</InputLabel>}
        {helperText && (
          <>
            <Typography
              variant=""
              sx={{
                color: "text.secondary",
                fontSize: "0.65rem",
                fontWeight: "bold",
                fontStyle: "italic",
              }}
            >
              {helperText}
            </Typography>
          </>
        )}
        <Autocomplete
          size="small"
          multiple={multiple}
          /* data */
          options={options.filter(
            (option) =>
              !formik.values[key] ||
              (multiple
                ? !formik.values[key].some(
                    (selected) => selected.value === option.value
                  )
                : formik.values[key].value !== option.value)
          )}
          disableCloseOnSelect={multiple}
          getOptionKey={(option) => option["value"]}
          /* display label */
          getOptionLabel={(option) => {
            // If the option has a property matching optionLabel, return it; otherwise, return _SELECT_DEFAULT
            return option["label"] ?? placeholder ?? _SELECT_DEFAULT;
          }}
          value={formik.values[key]}
          onChange={(e, value) => {
            // On change, update the entity value based on the new input value
            formik.setFieldValue(key, value ? value : null);
          }}
          renderInput={(params) => (
            // Render a TextField input with the provided label and params
            <TextField name={label} {...params} />
          )}
          componentsProps={{
            paper: {
              sx: {
                backgroundColor: "lightblue", // Change the background color of the dropdown
              },
            },
          }}
        />
        {formik.errors[key] ? (
          <ErrorMessageTypo error={formik.errors[key]} />
        ) : null}
      </FormGroup>
    </>
  );
};
